import React from 'react'

class TemplatesCell extends React.Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      tooltipOpen: false
    }
  }
  handleToggle = () => this.setState({ tooltipOpen: !this.state.tooltipOpen })
  renderTemplates = (template, index) => <li key={index}>{this.props.localizeValue(template.name, template.latinName)}</li>
  render () {
    const templates = this.props.dataItem[this.props.field]
    return (
      <td>
        {`[${templates.length}]`}
      </td>
    )
  }
}

function templateCellExport ({ dataItem, field, localizeValue }) {
  const templates = dataItem[field]

  return templates.map((template) => localizeValue(template.name, template.latinName)).join(',')
}

export {
  TemplatesCell,
  templateCellExport
}



// WEBPACK FOOTER //
// ./src/components/reporting/templatesCell.js